/**
 * Open Windows sidebar: closed unless CRDT or REST explicitly stored a value.
 * A missing key (signup nav cache, empty first CRDT room) must not open an
 * empty panel for new accounts.
 */
export function resolveDesktopSidebarOpen(
  crdtValue: boolean | undefined,
  restValue: boolean | undefined,
): boolean {
  return crdtValue !== undefined ? crdtValue : (restValue ?? false);
}
